import type { ModuleProps } from "../index";
import { useOptions } from "./options";
export const useComposable = (define: ModuleProps) => {
    //* 配置项
    const options = useOptions(define.origin);
    //* 响应式变量
    const refs = {};

    //* 函数列表
    const methods = {};

    return { options, refs, methods };
};
